import msgJp from './messages/message_jp';
const jp = {
    ...msgJp
}
export default jp;